/* ============================================================
   SUN ZAPPER CANADA — Custom JavaScript
   Sticky ATC on mobile, announcement bar auto-hide
   ============================================================ */

(function() {
  'use strict';

  /* ── Sticky ATC on mobile ── */
  function initStickyATC() {
    const stickyBar = document.querySelector('.sz-sticky-atc');
    if (!stickyBar) return;

    const productForm = document.querySelector('product-form, .product-form');
    if (!productForm) return;

    const submitBtn = productForm.querySelector('[type="submit"], .product-form__submit');

    window.addEventListener('scroll', function() {
      if (!submitBtn) return;
      const rect = submitBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }, { passive: true });

    // When sticky ATC is clicked, trigger the real form submit
    const stickyBtn = stickyBar.querySelector('.sz-sticky-atc-btn');
    if (stickyBtn && submitBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        submitBtn.click();
      });
    }
  }

  /* ── Announcement bar auto-hide on scroll ── */
  function initAnnouncementBarHide() {
    const bar = document.querySelector('.announcement-bar-section, .utility-bar');
    if (!bar) return;

    let lastScrollY = 0;
    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      if (scrollY > 80) {
        bar.style.marginTop = '-' + bar.offsetHeight + 'px';
        bar.style.transition = 'margin-top 0.3s ease';
      } else {
        bar.style.marginTop = '0';
      }
      lastScrollY = scrollY;
    }, { passive: true });
  }

  /* ── Init on DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initStickyATC();
      initAnnouncementBarHide();
    });
  } else {
    initStickyATC();
    initAnnouncementBarHide();
  }
})();
